import React from "react";
import { METERS, descriptor, currency } from "../lib/constants";
import { useLang } from "../lib/i18n";

const Meter = ({ m, value }) => {
  const { t } = useLang();
  return (
    <div data-testid={`meter-${m.key}`} className="space-y-1.5">
      <div className="flex items-baseline justify-between">
        <span className="text-[11px] uppercase tracking-[0.14em] font-semibold text-vin-dark/70">
          {t(m.label)}
        </span>
        <span className="text-xs font-semibold text-ink-soft">{t(descriptor(m, value))}</span>
      </div>
      <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
        <div
          className="meter-fill h-full rounded-full"
          style={{ width: `${value}%`, backgroundColor: m.stress ? "#5A2A85" : "#006BA8" }}
        />
      </div>
    </div>
  );
};

export const Dashboard = ({ state, quick = false }) => {
  const { t } = useLang();
  const left = state.money_left_this_month;
  return (
    <div
      data-testid="dashboard"
      className="bg-white rounded-lg border border-[var(--line)] shadow-sm p-5 sm:p-6"
    >
      <div className="pb-5 mb-5 border-b border-[var(--line)]">
        <div className="flex items-baseline justify-between">
          <span className="text-[11px] uppercase tracking-[0.14em] font-semibold text-vin-dark/70">
            {quick ? t("Right now") : t("This month")}
          </span>
          <span className="text-xs text-ink-soft">
            {currency(state.income_this_month)} {t("in")} · {currency(state.essentials)} {t("in essentials")}
          </span>
        </div>
        <div className="mt-1 flex items-baseline gap-2">
          <span
            data-testid="money-left-value"
            className={`text-2xl font-display font-semibold ${left < 0 ? "text-[#8E2929]" : "text-vin"}`}
          >
            {currency(left)}
          </span>
          <span className="text-sm text-ink-soft">{t("left after rent & basics")}</span>
        </div>
        <p className="text-[11px] text-ink-soft mt-1">
          {quick
            ? t("There is no savings to fall back on — nothing set aside for what comes next.")
            : t("There is no savings to fall back on — each month starts over.")}
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
        {METERS.map((m) => (
          <Meter key={m.key} m={m} value={state.indicators[m.key]} />
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
